/**
 * Public lead funnel service — submits and previews lead scores.
 * Endpoints are public (no auth required).
 */
import api from './api';
import type {
  LeadSubmitRequest,
  LeadScoreResponse,
  LeadScorePreviewResponse,
} from '../types/lead';

export async function submitLead(req: LeadSubmitRequest): Promise<LeadScoreResponse> {
  const { data } = await api.post<LeadScoreResponse>('/leads/submit', req);
  return data;
}

export async function previewScore(
  req: LeadSubmitRequest,
): Promise<LeadScorePreviewResponse> {
  const { data } = await api.post<LeadScorePreviewResponse>(
    '/leads/scoring/preview',
    req,
  );
  return data;
}
